var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconColorWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#8E0011"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-color--warning_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4.115 4.113h15.771v15.771H4.115z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-color--warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.841a.635.635 0 00.467-.189.635.635 0 00.188-.467.635.635 0 00-.188-.467.635.635 0 00-.468-.189.635.635 0 00-.467.189.635.635 0 00-.188.467c0 .186.062.342.188.467a.635.635 0 00.467.189zm0-2.967a.589.589 0 00.434-.175.59.59 0 00.175-.434V8.611a.59.59 0 00-.176-.434.59.59 0 00-.434-.175.589.589 0 00-.434.175.59.59 0 00-.175.434v3.654c0 .172.059.317.176.434a.59.59 0 00.434.175zm0 6.84a7.514 7.514 0 01-3.008-.608 7.79 7.79 0 01-2.45-1.648 7.79 7.79 0 01-1.65-2.45 7.508 7.508 0 01-.607-3.007c0-1.067.203-2.07.608-3.009a7.792 7.792 0 011.648-2.45 7.79 7.79 0 012.45-1.65 7.508 7.508 0 013.007-.607c1.067 0 2.07.203 3.009.608a7.792 7.792 0 012.45 1.648 7.791 7.791 0 011.65 2.45c.404.937.607 1.94.607 3.007 0 1.067-.203 2.07-.608 3.009a7.79 7.79 0 01-1.648 2.45 7.79 7.79 0 01-2.45 1.65 7.508 7.508 0 01-3.007.607zm0-1.218c1.813 0 3.35-.63 4.608-1.888 1.258-1.259 1.888-2.795 1.888-4.609 0-1.813-.63-3.35-1.888-4.608-1.259-1.258-2.795-1.888-4.609-1.888-1.813 0-3.35.63-4.608 1.888C6.133 8.65 5.503 10.186 5.503 12c0 1.814.63 3.35 1.888 4.609 1.259 1.258 2.795 1.888 4.608 1.888z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-color--warning-bd463157c5eed4b2ddd7010d22ddc488.svg";
export { SvgIconColorWarning as Component };